import { responseSchema } from '@/core/types/Response.ts'
import { z } from 'zod'
import { supplierSchema } from '@/modules/sales/clients/types/Supplier.ts'

export const supplierResponseSchema = responseSchema(supplierSchema)
export type SupplierResponseSchema = z.infer<typeof supplierResponseSchema>
